import theme from '@wavetrak/theme';

export const getStrokeColor = (selected?: boolean) => {
  if (selected) return theme.palette.text.light;
  if (selected === false) return theme.conditions.veryPoor;
  return theme.palette.text.brandSecondary;
};

export const getBackgroundFill = (selected?: boolean) =>
  selected === true ? theme.palette.text.brandSecondary : theme.palette.text.light;

const ThumbsIcon = ({
  selected,
  direction = 'up',
}: {
  selected?: boolean;
  direction?: 'up' | 'down';
}) => (
  <svg
    style={{ transform: direction === 'down' ? 'rotate(180deg)' : undefined }}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="4" fill={getBackgroundFill(selected)} />
    <path
      d="M15.5726 18.0999L19.2306 10C19.9582 10 20.6561 10.2845 21.1706 10.7908C21.6851 11.2972 21.9741 11.9839 21.9741 12.7V16.3H27.1503C27.4154 16.297 27.678 16.3508 27.9199 16.4577C28.1618 16.5645 28.3772 16.7218 28.5512 16.9187C28.7251 17.1156 28.8535 17.3474 28.9275 17.598C29.0014 17.8486 29.0191 18.112 28.9793 18.3699L27.7173 26.4699C27.6511 26.8991 27.4296 27.2903 27.0935 27.5715C26.7574 27.8527 26.3293 28.0048 25.8882 27.9999H15.5726M15.5726 18.0999V27.9999M15.5726 18.0999H12.829C12.3439 18.0999 11.8787 18.2896 11.5357 18.6272C11.1927 18.9647 11 19.4226 11 19.8999V26.1999C11 26.6773 11.1927 27.1351 11.5357 27.4727C11.8787 27.8102 12.3439 27.9999 12.829 27.9999H15.5726"
      stroke={getStrokeColor(selected)}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ThumbsIcon;
